module.exports = "<button mat-icon-button style=\"color: mediumpurple\" (click)=\"openBottomSheet()\"><mat-icon>help</mat-icon></button>"